export const AUTH = {
	SEND_LOGIN_CREDENTIALS: "SEND_LOGIN_CREDENTIALS",
	FORGOT_PASSWORD: "FORGOT_PASSWORD",
	RESET_PASSWORD: "RESET_PASSWORD",
	VALIDATE_TOKEN: "VALIDATE_TOKEN",
	CHANGE_PASSWORD: "CHANGE_PASSWORD"
};
